import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { UserPreferencesService } from '../../user-preferences/user-preferences.service';
import { Subscription } from '../../../../../node_modules/rxjs';
import { StudentService } from '../student.service';
import { UserService } from '../../user/user.service';

@Component({
  selector: 'student-name',
  template: '<span>{{formattedName}}</span>',
  styleUrls: ['./student-name.component.css']
})
export class StudentNameComponent implements OnInit, OnChanges {

  @Input() firstName: string;
  @Input() lastName: string;
  @Input() middleName: string;
  @Input() nickName: string;
  formattedName = '';
  generalPreferencesSubscription: Subscription;
  isComponentInitialized = false;

  constructor(
    private userPreferencesService: UserPreferencesService,
    private studentService: StudentService,
    private userService: UserService
  ) {
    this.generalPreferencesSubscription = this.userPreferencesService.observablegeneralPreferencesStream$.subscribe(
      preferences => {
        this.formatName();
      }
    );
  }

  ngOnInit() {
    this.formatName();
    this.isComponentInitialized = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.isComponentInitialized) {
      this.formatName();
    }
  }

  formatName() {
    if (this.userService.userType == 1) {
      this.formattedName = this.studentService.formatStudentName(this.firstName, this.middleName, this.lastName, this.nickName);
    }
    else {
      this.formattedName = this.firstName + ' ' + this.lastName;
    }
  }
}
